export const convertNumberToDisplayedNumberText = (value: number): string => value.toString().replace('.', ',');